export default __webpack_public_path__ + "static/048-a97571756384ad38894007903910e765.jpg";